export const MiniCloseOutIcon = ({ isRed = false }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path d="M8.20367e-05 1.71281L10.786 12.4987L11.9988 11.2859L1.21289 0.5L8.20367e-05 1.71281Z" fill={isRed ? '#F52500' : '#ABABAB'} />
      <path d="M10.7872 0.502035L0.00127817 11.2879L1.21409 12.5008L12 1.71484L10.7872 0.502035Z" fill={isRed ? '#F52500' : '#ABABAB'} />
    </svg>
  )
}
